export default {
	"70046c271624aceefdf18048e78721d9": "商品价格发生变化，请联系客服提供新下单链接～",
	"405381ab0d95a7fd1506e03f331e6c09": "我知道了",
	"9b04c6f904c8c575d43aeb92719a1fbc": "联系客服"
}
